import classes from "./LoginHead.module.scss";
import brandLogo from "../assets/CDAnalyticsLogo.png";
import { useContext } from "react";
import { Link } from "react-router-dom";
import ValidUserContext from "../authCheck";
import { LOGIN_PATH } from "../routes";

function LoginHead() {
  const validUserContext = useContext(ValidUserContext);

  const handleReset = (event) => {
    event.preventDefault();
    validUserContext.reset();
  };

  return (
    <div className={classes.brandBlock}>
      <Link to={LOGIN_PATH} onClick={handleReset}>
        <img
          className={classes.loginLogo}
          src={brandLogo}
          alt="CD Analytics"
        />
      </Link>
    </div>
  );
}

export default LoginHead;
